import config from './config';
import { Toast } from 'antd-mobile';
// import { createHashHistory } from 'history';
import $ from 'jquery';

var Server = function () {
}

Server.baseUrl = config.serverBaseUrl;
Server.serverAchievementBaseUrl = config.serverAchievementBaseUrl
Server.serverlisteningBaseUrl = config.serverlisteningBaseUrl

Server.GetColumnsList = function (data, successFunc) {
  var self = this;
  self.Ajax({
    url : self.baseUrl + "/listening/category/columns",
    type : "get",
    data : data,
    success : successFunc
  })
}
Server.getArticleContact = function (id, successFunc) {
  var self = this;
  let url = `${Server.baseUrl}/listening/article?id=${id}`
  self.Ajax({
    url: url,
    type : "get",
    success : successFunc
  })
}
Server.getLevelWeal = function (data, successFunc) {
  var self = this;
  self.Ajax({
    url: self.serverAchievementBaseUrl + "prize/info/get",
    type: "get",
    data: data,
    success: successFunc
  })
}
Server.getWeal = function (data, successFunc) {
  var self = this;
  self.Ajax({
    url: self.serverAchievementBaseUrl + "prize/receive",
    type: "post",
    data: data,
    success: successFunc
  })
}

Server.getUserInfo = function (successFunc) {
  var self = this
  self.Ajax({
    url: self.serverAchievementBaseUrl + 'act/achievement/info',
    type: "get",
    success: successFunc
  })
}

Server.getUserWelfare = function (data, successFunc) {
  var self = this
  self.Ajax({
    url: self.serverAchievementBaseUrl + 'prize/list',
    type: "get",
    data: data,
    success: successFunc
  })
}

Server.GetSubCat = function (data, successFunc) {
  var self = this;
  self.Ajax({
    url : self.baseUrl + "/listening/category/sub_cat",
    type : "get",
    data : data,
    success : successFunc
  })
}

Server.GetAllCategory = function (successFunc) {
  var self = this;
  self.Ajax({
    url : self.baseUrl + "/listening/category/all",
    type : "get",
    success: successFunc
  })
}

Server.Ajax = function(params){
  var me = this;
  if(!('processData' in params)){
    params.processData = true;
  }
  if(!('contentType' in params)){
    params.contentType = "application/x-www-form-urlencoded";
  }
  if(!('async' in params)){
    params.async = true ;
  }
  $.ajax({
    url : params.url,
    type : params.type || "get",
    dataType : params.dataType || "json",
    xhrFields: {
      withCredentials: true
    },
    crossDomain: true,
    async: params.async,
    data:params.data,
    processData: params.processData,
    contentType: params.contentType,
    success : function(json){
      params.success(json);
    },
    error:function(){
      // createHashHistory().push('/Exception/500');
      Toast.info('请求错误', 3);
      return;
      
    }
  })
}

export default Server;